import axios from "axios";
import { apiHeaders } from "../constants/variables";

export let baseUrl = "https://lcw-f1ef38a61e01.herokuapp.com/api/";
// export let baseUrl = "https://n6gk58dw-5001.inc1.devtunnels.ms/api/";

const api = async (path, params, method, formData) => {
  let userToken = localStorage.getItem("token");

  let options = {
    headers: {
      "Content-Type": formData
        ? apiHeaders.multipart_data
        : apiHeaders.application_json,
      ...(userToken && {
        Authorization: `Bearer ${userToken}`,
      }),
    },
    method: method,
    ...(params && { data: formData ? params : JSON.stringify(params) }),
  };

  console.log(baseUrl + path, options, "options");
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
